import store from './store';

export default store;



// WEBPACK FOOTER //
// ./src/app/store-pages/index.js